import Loadable from '../../components/loadable';

const ContactProfileActions = Loadable({
  loader: () => import('../../pages/contacts/contact_profile_actions'),
  type: 'block',
});

angular.module('gym').value('ContactProfileActions', ContactProfileActions);
